import { useMemo } from 'react';
import { token } from '@atlaskit/tokens';
import { STATE_COLOURS } from './ellipsis.tsx';
import { ValidationFlag } from './toPortInfo.tsx';

interface UseStrokeOptions {
	flag: ValidationFlag | undefined;
	isSelected: boolean;
	isHighlighted: boolean;
	isHovered: boolean;
}

/** Provides common colors for transition lines given the transition's state */
export const useStrokeColor = ({
	flag,
	isSelected,
	isHighlighted,
	isHovered,
}: UseStrokeOptions) => {
	const stroke = useMemo(() => {
		if (flag === ValidationFlag.Error) {
			return STATE_COLOURS.error;
		}

		if (flag === ValidationFlag.Warn) {
			return STATE_COLOURS.warning;
		}

		if (isSelected) {
			return STATE_COLOURS.selected;
		}

		if (isHighlighted || isHovered) {
			return token('color.chart.gray.boldest.hovered');
		}

		return token('color.chart.gray.bold');
	}, [flag, isHighlighted, isHovered, isSelected]);

	return stroke;
};
